/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {SoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/SoundConfig";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {SoundManager} from "../../sound/SoundManager";

export class SpinStop implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;

    /**
     * @constructs
     * @param stagger
     * @param abortStagger
     */
    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    /**
     * @inheritDoc
     */
    public getAnimation(): Timeline | null {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            this.stopSpin();
        });

        return tl;
    }

    /**
     * @inheritDoc
     */
    public abort(): Timeline | null {
        return this.getAnimation();
    }

    /**
     * To stop the reel spin sound.
     */
    private stopSpin(): void {
        if (SoundConfig.instance.REELS_SPIN_START) {
            SoundManager.stopSoundEffect(SoundConfig.instance.REELS_SPIN_START[0]);
        }
    }
}